import * as React from "react";
import { CollectionShort } from "../../../types/Collection";
import { Book } from "../../../types/Book";
import getCollection from "../../../requests/getCollection";
import FeedList from "../../Feed/FeedList/FeedList";
import { API_URL } from "../../../utils";

interface Props {
	bookId: number;
}

const OtherBooks: React.FC<Props> = ({ bookId }) => {
	const [books, setBooks] = React.useState<{
		related: Book[],
		collection: Book[]
	}>({
		related: [],
		collection: []
	});
	const [loading, setLoading] = React.useState(false);

	React.useEffect(() => {
		setLoading(true);

		fetch(`${API_URL}/collections/relatedForBook?id=${bookId}`, {
			credentials: 'include'
		}).then(data => data.json()).then(data => {
			setBooks(data);
			setLoading(false);
		});
	}, [bookId]);

	return <>
		{books.related.length > 0 && <div><div>
			Похожие
		</div>

		<FeedList books={books.related} /></div>}

		<FeedList books={books?.collection} loading={loading}/>
	</>;
};

export default OtherBooks;
